import React from "react";
import { Routes, Route } from "react-router-dom";
import { PageAreas, PageCategories, PagePauses, PagePlatforms } from "../pages/inmersys";
import { CmsRoot } from "./type_router";
import { PageTag } from "../pages/inmersys/Tags/PageTag";

export const CmsRouter = () => {
    return (
        <Routes>
            <Route path={CmsRoot.area} element={<PageAreas />} />
            <Route path={CmsRoot.plaforms} element={<PagePlatforms />} />
            <Route path={CmsRoot.categories} element={<PageCategories />} />
            <Route path={CmsRoot.pauses} element={<PagePauses />} />
            <Route path={CmsRoot.tags} element={<PageTag />} />
        </Routes>
    );
};

